import { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'redux/store';
import { getFolders } from '../../../../../../../redux/slices/lists/foldersSlice';
import { buildFolderPathOptions } from '../../../../../../../helpers/folderPaths';
import { EditSelect } from 'components/forms/EditSelect';

interface FoldersProps {
  selectedValue: string;
  zoneName: string | null | undefined;
  onChange: (value: string) => void;
}

/**
 * Folder path dropdown for node definitions (edit form).
 * Path format: TopLevel/Subfolder/Leaf. Options are built from folders in the selected zone.
 */
const Folders = ({ selectedValue, zoneName, onChange }: FoldersProps) => {
  const dispatch = useAppDispatch();
  const { folders } = useAppSelector((state) => state?.listOfFolders ?? { folders: [] });

  useEffect(() => {
    if (folders?.length) return;
    dispatch(getFolders());
  }, [dispatch, folders?.length]);

  const options = buildFolderPathOptions(folders ?? [], zoneName);

  return (
    <div className="mb-2">
      <EditSelect
        label="Folder (path)"
        value={selectedValue || ''}
        onChange={onChange}
        options={options.map((opt) => ({
          key: opt.value || '',
          value: opt.value,
          label: opt.label || 'None',
        }))}
      />
    </div>
  );
};

export default Folders;
